// removed by extract-text-webpack-plugin
module.exports = {"whatWeDo":"src-pages----index-module---whatWeDo---2QUQV","aboutArtiseq":"src-pages----index-module---aboutArtiseq---7qjIT","getInTouch":"src-pages----index-module---getInTouch---1cTt1","whatWeDoImg":"src-pages----index-module---whatWeDoImg---aUfv2","aboutArtiseqImg":"src-pages----index-module---aboutArtiseqImg---10HGU","getInTouchContent":"src-pages----index-module---getInTouchContent---3Xd7V","contactForm":"src-pages----index-module---contactForm---11pWH"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.css
// module id = 310
// module chunks = 35783957827783